import React from 'react'
import { Button, Checkbox, Tooltip } from 'antd'
import styled from 'styled-components'
import {
  EXCLUDE_FROM_GROSS_PROFIT_COLUMN_LABEL,
  GR_EXCLUDE_FROM_GP_ADD_TO_LIST_LABEL,
  getExcludeFromGrossProfitAriaLabel,
  getExcludeFromGrossProfitDuplicateTitleTooltip,
  getVenueProductSupplierLabel,
  hasDuplicateShoppingListTitle,
} from 'src/utils/excludeFromGrossProfit'

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const SupplierCue = styled.span`
  display: block;
  max-width: 90px;
  margin-top: 2px;
  overflow: hidden;
  color: #8c8c8c;
  font-size: 10px;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const AddToListButton = styled(Button)`
  && {
    display: block;
    height: auto;
    max-width: 100px;
    margin-top: 4px;
    padding: 0;
    font-size: 11px;
    line-height: 1.2;
    white-space: normal;
  }
`

const ExcludeFromGrossProfitTick = ({
  product,
  products,
  checked,
  onChange,
  disabled = false,
  unavailableTooltip,
  onAddToShoppingList,
  addToShoppingListBusy = false,
}) => {
  const duplicate =
    !disabled && hasDuplicateShoppingListTitle(products, product)
  const supplierLabel = duplicate ? getVenueProductSupplierLabel(product) : ''
  const tooltip =
    unavailableTooltip ||
    (duplicate
      ? getExcludeFromGrossProfitDuplicateTitleTooltip({ product, products })
      : null)
  const ariaLabel = unavailableTooltip
    ? `${EXCLUDE_FROM_GROSS_PROFIT_COLUMN_LABEL} unavailable`
    : getExcludeFromGrossProfitAriaLabel({ product, products })

  const checkbox = (
    <Checkbox
      disabled={disabled}
      checked={Boolean(checked)}
      aria-label={ariaLabel}
      onChange={onChange}
    />
  )

  return (
    <Cell>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <span>{checkbox}</span>
        </Tooltip>
      ) : (
        checkbox
      )}
      {duplicate ? (
        <SupplierCue
          data-testid='exclude-from-gp-supplier-cue'
          title={supplierLabel}
        >
          {supplierLabel}
        </SupplierCue>
      ) : null}
      {onAddToShoppingList ? (
        <AddToListButton
          type='link'
          data-testid='exclude-from-gp-add-to-list'
          loading={addToShoppingListBusy}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            onAddToShoppingList()
          }}
        >
          {GR_EXCLUDE_FROM_GP_ADD_TO_LIST_LABEL}
        </AddToListButton>
      ) : null}
    </Cell>
  )
}

export default ExcludeFromGrossProfitTick
